// extracted by mini-css-extract-plugin
module.exports = {"brand":"eBt7ODjawkiPp0fLb-3Gj","link":"_6xXDwGTWrjX1CSK-bQ3JL","imageLogo":"_1ecns3_z7ZFkPlvCVgKmLf","textLogo":"_2_FEvGk7EpLbCr2izM41-2"};